var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"relative w-full max-w-full h-full"},[_c('video',{staticClass:"w-full h-full block rounded-md",attrs:{"src":_vm.src,"poster":_vm.poster,"controls":_vm.controls,"autoplay":_vm.autoplay,"loop":_vm.loop},domProps:{"muted":_vm.muted}},[_vm._v(" Your browser does not support the video tag. ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }